import uniqId from 'uniq-id'
import request from '@/utils/request'

export default {
	addMessage: ({ commit, state }, message) => {
		const alreadyExistMessage = state.messages.find(it => {
			let equal = true

			Object.keys(message).forEach(key => {
				if (it[key] && it[key] != message[key]) {
					equal = false
				}
			})

			return equal
		})

		if (alreadyExistMessage) {
			commit('REMOVE_MESSAGE', alreadyExistMessage.id)
		}

		let messageObj = Object.assign({ id: uniqId(), time: 5000 }, message)

		if (messageObj.debug && process.env.NODE_ENV != 'development') {
			messageObj = Object.assign(messageObj, {
				message: 'unknown',
				type: 'error',
				locale: true
			})
		}

		commit('ADD_MESSAGE', messageObj)

		setTimeout(() => commit('REMOVE_MESSAGE', messageObj.id), messageObj.time)
	},

	getTariffs: ({ commit, dispatch, rootState }) => {
		getOptions(commit, dispatch, rootState, 'rates', 'SET_TARIFFS')
	},

	getOptions: ({ commit, dispatch, rootState }) => {
		getOptions(commit, dispatch, rootState, 'options', 'SET_OPTIONS')
	}
}

async function getOptions(commit, dispatch, rootState, url, commitName) {
	const city = rootState.app.defaultCity

	if (!city || !city.code) {
		return dispatch('addMessage', {
			message: 'chooseCity',
			type: 'info',
			locale: true
		})
	}

	request({ method: 'get', url: `/${rootState.app.countryCode}${city.code}/${url}` })
		.then(res => {
			if (res && res.data && res.data.length) {
				commit(commitName, res.data)
			} else {
				commit(commitName, [])
			}
		}).catch(err => {
			commit(commitName, [])

			dispatch('addMessage', {
				message: err && err.message,
				debug: true
			})
		})
}
